// Global namespace
window.theme = window.theme || {};

//////////////////////// UTILITY FUNCTIONS //////////////////////////
/**
 * Extend theme.utils instead of replacing it
 */
theme.utils = theme.utils || {};

/**
 * Check Device Type
 * @param {string} typeOf
 * @returns {boolean}
 */
theme.utils.isDevice = (typeOf) => {
  // check different device types and map to window.matchMedia
  const devices = {
    mobile: "(max-width: 480px)",
    tablet: "(min-width: 481px) and (max-width: 768px)",
    desktop: "(min-width: 769px) and (max-width: 979px)",
    largeDesktop: "(min-width: 980px)",
  };

  // check if device type is valid
  if (!devices[typeOf]) {
    throw new Error("Device type is not valid");
  }

  // return true if typeOf matches the window.matchMedia
  return window.matchMedia(devices[typeOf]).matches;
};

/**
 * Check if isMobile
 * @returns {boolean}
 */
theme.utils.isMobile = () => {
  let w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  if (w <= 768) {
    return true;
  } else {
    return false;
  }
};

/**
 * Check if given element is in current viewport
 * @param {selector} el
 * @returns {boolean}
 */
theme.utils.isInViewport = (el) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
//////////////////////// THEME LAB FUNCTIONS //////////////////////////

// Init Main Javascript
theme.initLab = () => {
  // all custom js init goes here
};

/*************************************************************************************/
/********************************* DO NOT EDIT BELOW *********************************/
/*************************************************************************************/
theme.initLabBranding = () => {
  const brand1 = [
      "background: #000639",
      "padding: 20px",
      "color: #fff",
      "font-size: 1.9em",
      'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
      "font-weight: bold",
      "width: 400px",
    ].join(";"),
    brand2 = [
      "background: #fff",
      "padding: 0px",
      "color: #000639",
      "font-size: 1.1em",
      "line-height: 1.2em",
      'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
      "font-weight: bold",
      "text-decoration: none",
      "width: 400px",
    ].join(";");
  console &&
    console.log &&
    (console.log("%c shoplab", brand1),
    console.log("%c Shopify Experts \n www.shoplab.cc", brand2));
};

theme.initProductImageSwatcher = async (sectionID, productID) => {
  const $templateSectionSelector = document.querySelector(
    `#ProductSection-${sectionID}-${productID}`
  );

  if (!$templateSectionSelector) {
    console.warn(`[Swatcher] ProductSection not found: #ProductSection-${sectionID}-${productID}`);
    return;
  }

  const $colorSwatchImageWrapper = $templateSectionSelector.querySelector(
    ".color-swatcher-images"
  );

  if (!$colorSwatchImageWrapper) {
    console.log(`[Swatcher] No color swatcher wrapper found for product ${productID}`);
    return;
  }

  // definitions
  // strip the "cluster:" prefix — a colon makes predictive search treat the term as
  // unsupported filter syntax and silently return a generic fallback list instead
  const currentClusterTag = ($templateSectionSelector.dataset.clTag || "").replace(
    "cluster:",
    ""
  );
  const currentProductHandle = $templateSectionSelector.dataset.productHandle;

  if (!currentClusterTag) {
    console.log(`[Swatcher] No cluster tag found for product ${productID}`);
    return;
  }

  const query = `${currentClusterTag}&resources[type]=product&resources[limit]=9&resources[options][fields]=tag`;

  /**
   * Get product.json data for each product (return actually product)
   * @param {string} query
   * @return {Promise<*>}
   */

  const getProductData = async (query) => {
    try {
      if (!query) return;

      const response = await fetch(`/search/suggest.json?q=${query}`);
      const data = await response.json();
      const products = data.resources.results.products;

      // always show the current product first, even if search didn't return it
      const currentProductIndex = products.findIndex(
        (product) => product.handle === currentProductHandle
      );

      if (currentProductIndex > -1) products.splice(currentProductIndex, 1);
      products.unshift({ handle: currentProductHandle });

      return products;
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Get product color using product.json data (return actually color)
   * @return {Promise}
   */
  const getProductColor = async () => {
    try {
      const products = await getProductData(query);

      if (!products) throw new Error("Failed to fetch products!");

      return await Promise.all(
        products.map(async (product) => {
          const windowLocale = window.Shopify.locale;
          let fetchURL = `/products/${product.handle}.json`;

          if (windowLocale != "de") {
            fetchURL = `/${windowLocale}/products/${product.handle}.json`;
          }

          const response = await fetch(fetchURL);
          const data = await response.json();

          let colorName = data.product.variants[0].option1;

          const itemImageArray = data.product.images;
          const productHandle = data.product.handle;

          let itemColor = colorName;

          // Get first image from the itemImageArray
          const itemImage = itemImageArray[0];

          return {
            productHandle,
            itemImage,
            itemColor,
          };
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Build the html layout and inject it into the DOM
   * @return {Promise<void>}
   */
  const buildHTML = async () => {
    try {
      const colors = await getProductColor();

      if (!colors) return;

      colors.forEach(({ productHandle, itemImage, itemColor }) => {
        // mark by handle, not by position — the current colour isn't always first
        const activeClass =
          productHandle === currentProductHandle ? " active" : "";

        // Create the layout
        let htmlLayout = `
                <a class="color-swatch-image-wrapper${activeClass}" href="/products/${productHandle}">
                <div class="image_swatch_wrapper">
                  <img src="${itemImage.src}" alt="${itemImage.alt}" />
                </div>
                  <span class="color">
                    ${itemColor}
                  </span>
                </a>
              `;
        // Inject the HTML
        $colorSwatchImageWrapper.insertAdjacentHTML("beforeend", htmlLayout);
      });

      //remove skeleton
      $templateSectionSelector
        .querySelector(".content_wrapper")
        .classList.remove("skeleton");
    } catch (error) {
      console.error(error);
    }
  };

  // Paint the DOM
  await buildHTML();
};

/**
 * Judge.me Component
 * Displays the average rating and review content
 */
class JudgemeComponent extends HTMLElement {
  constructor() {
    super();
    this.averageRating = null;
    this.judgemeWidget = null;
    this.customRatingElement = null;
  }

  connectedCallback() {
    this.averageRating = this.querySelector('[data-average-rating]')?.dataset?.averageRating;
    this.judgemeWidget = this.querySelector('.jdgm-widget');
    
    if (this.judgemeWidget) {
      this.judgemeWidget.style.display = 'none';
      this.init();
    }
  }

  init() {
    if (!this.averageRating || !this.judgemeWidget) return;

    const temp = Number(this.averageRating);
    if (!Number.isFinite(temp) || temp < 1) return;
    
    // Check if custom element already exists
    if (this.customRatingElement) return;
    
    // Get a copy of the stars element
    const starsElement = this.judgemeWidget.querySelector('.jdgm-prev-badge__stars');
    if (!starsElement) return;
    
    const starsClone = starsElement.cloneNode(true);
    
    // Create a new custom element for our rating display
    this.customRatingElement = document.createElement('div');
    this.customRatingElement.className = 'judgeme-component';
    
    // Append the cloned stars
    this.customRatingElement.appendChild(starsClone);
    
    // Add the average rating text
    const ratingText = document.createElement('span');
    ratingText.className = 'judgeme-component__text';
    ratingText.textContent = `(${this.averageRating})`;
    this.customRatingElement.appendChild(ratingText);
    
    // Append it after the Judge.me widget
    this.insertAdjacentElement('afterend', this.customRatingElement);
  }
}

if (!customElements.get('judgeme-component'))
  customElements.define('judgeme-component', JudgemeComponent);

/**
 * Custom DOMready function
 * @param {*} callback
 */

theme.DOMready = (callback) => {
  if (document.readyState !== "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
theme.DOMready(() => {
  // Init Main JS
  theme.initLab();
  // Init Branding
  theme.initLabBranding();
  // dispatch customEvent
  document.dispatchEvent(new CustomEvent("lab:page-loaded"));

  // HACKS
  // wait for 5 seconds and then run function => hide omnisend
  const omnisendContainer = document.querySelector(
    "#omnisend-dynamic-container"
  );

  if (omnisendContainer) {
    setTimeout(() => {
      omnisendContainer.style.display = "none";
    }, 4000);
  }

  document.addEventListener("quickview:loaded", function (evt) {
    // init image swatcher
    theme.initProductImageSwatcher(evt.detail.productId, evt.detail.id);
  });
});
